import * as yup from "yup";

/*
 * @description
 * Валидация номера телефона, с функцией trim() для обрезания лищних пробелов
 * с фиксированной длиной 18
 */
export const phoneValidation = yup
  .string()
  .trim()
  .length(18, "Введите номер телефона");

/*
 * @description
 * Валидация номера телефона, с функцией trim() для обрезания лищних пробелов
 * с фиксированной длиной 18, поле обязательна для заполнения
 */
export const phoneValidationRequired = phoneValidation.required(
  "Введите номер телефона"
);

/**
 * @description
 * Валидация электронной почты, с функцией trim() для обрезания лищних пробелов,
 * поле обязательна для заполнения
 */
export const emailValidation = yup
  .string()
  .trim()
  .email("Введите email")
  .required("Введите email")
  .test("email validate", "Введите email", (value) =>
    /^([^ ]+@[^ ]+\.[a-z]{2,6}|)$/.test(value)
  );